import React, { useRef, useEffect, useContext, useState } from 'react';
import { SyrapayHostedFormTypes } from './SyrapayHostedFormTypes';
import {
  HOSTED_FORM_ID,
  TRANSACTION_ID,
  ACCOUNT_TOKEN,
  HOSTED_PAYMENTS_RESPONSE,
  HOSTED_FORM_SCRIPT_SOURCE,
  HOSTED_FORM_OPERATION,
  CARD_ENTRY_CONTEXT,
  HOSTED_FORM_TOKEN_OPERATION,
} from './Constants';
import { PaymentContext } from './context/PaymentContext';

const SyrapayHostedForm = ({
  amount,
  shouldSaveCard,
  authKey,
  hostedFormSubmitHandler,
  paymentCancellationHandler,
  tokenOnly = false,
}: SyrapayHostedFormTypes.THostedForm) => {
  const submitButtonRef = useRef<any>(null);
  const paymentContext = useContext(PaymentContext);
  const [componentKey, remountChildComponents] = useState(false);
  const isCaptureEnabled = useRef(false);

  const onCompletion = async () => {
    paymentContext?.setDisableFormSubmit(false);
    if (document) {
      const transactionId = (document.getElementById(
        TRANSACTION_ID
      ) as HTMLInputElement).value;
      const token = (document.getElementById(ACCOUNT_TOKEN) as HTMLInputElement)
        .value;
      const response = (document.getElementById(
        HOSTED_PAYMENTS_RESPONSE
      ) as HTMLInputElement).value;
      if ((transactionId || token) && isCaptureEnabled.current) {
        isCaptureEnabled.current = false;
        const jsonOtherResponse = await JSON.parse(response);
        hostedFormSubmitHandler(transactionId, token, jsonOtherResponse);
        paymentContext?.setTransactionId(transactionId);
        paymentContext?.setToken(token);
        remountChildComponents(!componentKey);
      }
    }
  };

  const onLoadFullSteamForm = () => {
    // @ts-ignore
    setupFullsteamHostedPayments({
      showZip: true,
      authenticationKey: authKey,
      showAddress1: true,
      formId: HOSTED_FORM_ID,
      showNameOnAccount: true,
      includeToken: shouldSaveCard,
      completionCallback: onCompletion,
      cancellationCallback: paymentCancellationHandler,
      cardEntryContext: CARD_ENTRY_CONTEXT,
      operationType: tokenOnly
        ? HOSTED_FORM_TOKEN_OPERATION
        : HOSTED_FORM_OPERATION,
      ...(!tokenOnly && { paymentAmount: amount }),
    });
    submitButtonRef.current.click();
  };

  const addJQueryScriptOfHostedForm = () => {
    const currentForm = document.getElementById(HOSTED_FORM_ID);
    const hostedFormScript = document.createElement('script');
    hostedFormScript.src = HOSTED_FORM_SCRIPT_SOURCE || '';
    hostedFormScript.type = 'text/javascript';
    hostedFormScript.onload = onLoadFullSteamForm;
    // @ts-ignore
    currentForm.appendChild(hostedFormScript);
  };

  useEffect(() => {
    isCaptureEnabled.current = true;
    addJQueryScriptOfHostedForm();
    paymentContext?.setDisableFormSubmit(true);
  }, [paymentContext?.authenticationKey]);

  return (
    <React.Fragment
      key={`${paymentContext?.authenticationKey}-${componentKey}`}
    >
      <input type="hidden" name={TRANSACTION_ID} id={TRANSACTION_ID} />
      <input type="hidden" name={ACCOUNT_TOKEN} id={ACCOUNT_TOKEN} />
      <input
        type="hidden"
        name={HOSTED_PAYMENTS_RESPONSE}
        id={HOSTED_PAYMENTS_RESPONSE}
      />
      <input
        ref={submitButtonRef}
        type="submit"
        id="submitButton"
        style={{
          display: 'none',
        }}
      />
      <div id="fullsteam-hosted-card-data" />
    </React.Fragment>
  );
};

export default SyrapayHostedForm;
